var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9,0a9,9,0,1,0,9,9A9.01,9.01,0,0,0,9,0ZM9,16.768A7.768,7.768,0,1,1,16.769,9,7.777,7.777,0,0,1,9,16.768Z",
    transform: "translate(-0.001)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.568,49.035h-4.275v-4.67a.616.616,0,0,0-1.232,0v5.286a.616.616,0,0,0,.616.616h4.891a.616.616,0,1,0,0-1.232Z",
    transform: "translate(-90.925 -40.156)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.f4c3d469a3db7d0798ad9bde7bec7013.svg";
export { ForwardRef as ReactComponent };